import dashboard from './dashboard';
import hhohho from './hhohho';
import lubombo from './lubombo';
import manzini from './manzini';
import shiselweni from './shiselweni';

// ==============================|| MENU ITEMS ||============================== //

const roadsMenuItems = {
    items: [dashboard, hhohho, manzini, shiselweni, lubombo]
};

export default roadsMenuItems;
